export const PAYMENT_OPTIONS_LOGOS = {
    IDEAL: {
        displayName: 'iDeal',
        name: 'ideal',
        icon: <img src="/images/logos/ideal-logo.svg" alt="iDeal" />,
    },
    PAYPAL: {
        displayName: 'PayPal',
        name: 'paypal',
        icon: <img src="/images/logos/paypal-logo.svg" alt="PayPal" />,
    },
    AMEX: {
        displayName: 'American Express',
        name: 'amex',
        icon: <img src="/images/logos/amex-logo.svg" alt="American Express" />,
    },
    VISA: {
        displayName: 'Visa',
        name: 'visa',
        icon: <img src="/images/logos/visa-logo.svg" alt="Visa" />,
    },
    VISA_OLYMPICS: {
        displayName: 'Visa',
        name: 'visa',
        icon: <img src="/images/logos/visa-olympics-logo.svg" alt="Visa Olympics" />,
    },
    MASTERCARD: {
        displayName: 'MasterCard',
        name: 'mastercard',
        icon: <img src="/images/logos/mastercard-logo.svg" alt="MasterCard" />,
    },
    APPLE_PAY: {
        displayName: 'Apple Pay',
        name: 'apple-pay',
        icon: <img src="/images/logos/apple-pay-logo.svg" alt="Apple Pay" />,
    },
    TRUSTLY: {
        displayName: 'Trustly',
        name: 'trustly',
        icon: <img src="/images/logos/trustly-logo.svg" alt="Trustly" />,
    },
    KLARNA: {
        displayName: 'Klarna',
        name: 'sofort',
        icon: <img src="/images/logos/klarna-logo.svg" alt="Klarna" />,
    },
    CARTE_BANCAIRE: {
        displayName: 'Carte Bancaire',
        name: 'cartebancaire',
        icon: <img src="/images/logos/carte-bancaire-logo.svg" alt="Carte Bancaire" />,
    },
};
